var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internal-Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile_01_Dashboard",
    transform: "translate(-38.000000, -2173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-7.000000, 2150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#E9E9E9",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 390,
    height: 81,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(45.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.981762272,4.78857039 C6.37869985,1.59619013 9.24082655,0 9.56814237,0 C9.89538899,0 12.7158847,1.59551526 18.0296294,4.78654579 C18.631684,5.14806771 19,5.7988762 19,6.50113524 L19,18 C19,19.1045695 18.1045695,20 17,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,6.50997104 C-7.06618662e-06,5.8029774 0.373254767,5.14851292 0.981762272,4.78857039 Z",
    id: "Rectangle",
    className: "icon-color-base"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,11 C9.88071187,11 11,12.1192881 11,13.5 L11,20 L11,20 L6,20 L6,13.5 C6,12.1192881 7.11928813,11 8.5,11 Z",
    id: "Rectangle",
    fill: "#9AE0EA"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHome);
export default __webpack_public_path__ + "static/media/nav-home.1aecd7a79f4488a1f0df31ec3b97ce80.svg";
export { ForwardRef as ReactComponent };